<template>  
     <ul class="breadcrumb">
      <li
        v-for="(breadcrumb, idx) in breadcrumbList"
        :key="idx"
        @click="routeTo(idx)"
        class="breadcrumb-item my-auto"
        :class="{'linked pointer-link': !!breadcrumb.link}">

        {{ breadcrumb.name }}

      </li>
      <li class="ms-4 my-auto" v-if="$route.fullPath == '/upi/paymentlink' || $route.fullPath.startsWith('/upi/paymentlink/?pageId=')">
        <div class="input-group-append">
          <select class="form-select" v-model="linkPaymentPageId" v-on:change="changeFilter()">
              <option value="1">Dashboard</option>
              <option value="3">API</option>
          </select>
        </div>
      </li>
    </ul> 
</template>
<script>
export default {
  name: 'Breadcrumb',
  data () {
    return {
      breadcrumbList: [],
      linkPaymentPageId: this.$route.query.pageId ? this.$route.query.pageId : 1, 
    }
  },
  mounted () { this.updateList() },
  watch: { '$route' () { this.updateList() } },
  methods: {
    routeTo (pRouteTo) {
      if (this.breadcrumbList[pRouteTo].link) this.$router.push(this.breadcrumbList[pRouteTo].link)
    },
    updateList () { 
      this.breadcrumbList = this.$route.meta.breadcrumb ?this.$route.meta.breadcrumb.map(item => {
        let sk;
        if(this.$route.query.sk)
        {
          sk = this.$route.query.sk;
        }
        else if(this.$route.params.sk)
        {
          sk = this.$route.params.sk;
        }
        else
        {
          sk = null;
        }
        let link = item.link ? item.link.replace(':sk', sk) : null;
        return {
          name: item.name,
          link: link,
        };
      }): [];
    },
    changeFilter() {
      this.$router.push(`/upi/paymentlink/?pageId=${this.linkPaymentPageId}`);
    }
  }
}
</script>